<script>
import axios from "axios";
import Layout from "../layouts/main";
import PageHeader from "@/components/page-header";
// import axios from "axios";

// import "datatables.net-bs5";
// import "jszip";
// import "pdfmake";
// import "datatables.net-buttons-bs5";
// import "datatables.net-buttons/js/buttons.colVis";
// import "datatables.net-buttons/js/buttons.flash";
// import "datatables.net-buttons/js/buttons.html5";
// import "datatables.net-buttons/js/buttons.print";

// import $ from "jquery";

export default {
  page: {
    title: "Reports",
    meta: [
      {
        name: "Reports",
      },
    ],
  },
  components: { Layout, PageHeader },
  mounted() {
    this.getDowmloadReports();
  },
  data() {
    return {
      title: "",
      items: [
        {
          text: "",
          href: "/",
        },
      ],
      downloadReports: [],
      isDownloadReportsLoading: false,
    };
  },
  methods: {
    getDowmloadReports() {
      this.isDownloadReportsLoading = true;
      axios.get("admin/reportsProgress").then((res) => {
        this.downloadReports = res.data.response;
        this.isDownloadReportsLoading = false;
      });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card">
      <div class="card-body">
        <b-tabs
          justified
          nav-class="nav-tabs-custom"
          content-class="p-3 text-muted"
        >
          <b-tab active class="border-0">
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="fas fa-home"></i>
              </span>
              <span class="d-none d-sm-inline-block">Reports</span>
            </template>

            <!-- <div class="d-flex">
              <div class="me-2">
                <h5 class="card-title mb-3">Reports</h5>
              </div>

              <div class="mb-4 mdl-btns ms-auto">
              </div>
            </div> -->

            <div class="mb-4 mt-4">
              <!-- <h5 class="card-title mb-5 mt-5"></h5> -->

              <table id="masterTable" class="table">
                <thead class="table-light">
                  <tr>
                    <th>Report Name</th>
                    <th>Description</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><strong> Master Report V2 </strong></td>
                    <td>
                      Center First Name Last Name Primary Phone Number Email
                      address DOB Gender Address Line 1 Address Line 2 City
                      State Zip Code Category Role Assigned to Mentor Building
                      Volunteer Department Status Application Date DHS Clearance
                      Date Mentor/Volunteer Orientation Date Assigned to Role
                      Date Church Name Church City Church State Current
                      Occupation Name of Employer City/State of Employer
                      Hobbies, Interests, Passions Foreign Languages
                      Opportunities Character Reference First Name Character
                      Reference Last Name Gender
                    </td>
                    <td>
                      <router-link
                        class="btn btn-primary"
                        tag="a"
                        :to="`/report/masterv2`"
                      >
                        Generate Report
                      </router-link>
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Volunteer Management Master</strong></td>
                    <td>
                      Location, First Name, Last Name, Email, Phone, status,
                      category, Role, Assign Date, Gender
                    </td>
                    <td>
                      <router-link
                        class="btn btn-primary"
                        tag="a"
                        :to="`/report/rep1`"
                      >
                        Generate Report
                      </router-link>
                    </td>
                  </tr>
                  <tr>
                    <!-- <td> <strong> Report-6 </strong> </td> -->
                    <td><strong> Social Security Report </strong></td>
                    <td>
                      resource id, center, Applucation Date, first name, last
                      name, category, status, SSN
                    </td>
                    <td>
                      <router-link
                        class="btn btn-primary"
                        tag="a"
                        :to="`/report/rep6`"
                      >
                        Generate Report
                      </router-link>
                    </td>
                  </tr>

                  <tr>
                    <td><strong> Newsletter Report </strong></td>
                    <td>
                      center, first name, last name, Email Address, category,
                      Building, Deppartment Assign To, status,
                    </td>
                    <td>
                      <router-link
                        class="btn btn-primary"
                        tag="a"
                        :to="`/report/rep7`"
                      >
                        Generate Report
                      </router-link>
                    </td>
                  </tr>

                  <tr>
                    <td><strong> MentorHours Report </strong></td>
                    <td>
                      center, first name, last name, category, Building, Assign
                      To, Hours logged by month, Hours logged by quarter,
                      Comments/Notes,
                    </td>
                    <td>
                      <router-link
                        class="btn btn-primary"
                        tag="a"
                        :to="`/report/mentorHours`"
                      >
                        Generate Report
                      </router-link>
                    </td>
                  </tr>

                  <tr>
                    <td><strong> Weekly Birthday Report </strong></td>
                    <td>
                      first name, last name, email, DOB, locatoin, address
                    </td>
                    <td>
                      <router-link
                        class="btn btn-primary"
                        tag="a"
                        :to="`/report/isWeeklyBirthday`"
                      >
                        Generate Report
                      </router-link>
                    </td>
                  </tr>
                  <tr>
                    <td><strong> Monthly CCM Checkin </strong></td>
                    <td>
                      center, first name, last name, phone, email, building,
                      Assign To, start date, end date,
                    </td>
                    <td>
                      <router-link
                        class="btn btn-primary"
                        tag="a"
                        :to="`/report/MentorRolesStart`"
                      >
                        Generate Report
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-tab>

          <b-tab class="border-0">
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="fas fa-home"></i>
              </span>
              <span class="d-none d-sm-inline-block">Download Reports</span>
            </template>
            <div class="mb-4 mt-4">
              <!-- <h5 class="card-title mb-5 mt-5"></h5> -->

              <table id="masterTable" class="table">
                <thead class="table-light">
                  <tr>
                    <th>ID</th>
                    <th>Email</th>
                    <th>Name</th>
                    <th>Path</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="isDownloadReportsLoading">
                    <td colspan="4" class="text-center p-0">
                      <b-spinner
                        class="m-2"
                        variant="primary"
                        role="status"
                      ></b-spinner>
                    </td>
                  </tr>
                  <tr v-for="(data, index) in downloadReports" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>
                      {{ data.user_email }}
                    </td>
                    <td>
                      {{ data.name }}
                    </td>
                    <td v-if="data.status === 'Completed'">
                      <a :href="data.path" download> Download File </a>
                    </td>
                    <td v-else></td>
                    <td>
                      {{ data.status }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </Layout>
</template>
